import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ZONE_EDIT_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ZONE_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const zoneEdit = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ZONE_EDIT_REQUEST });

    axios.put(`/zones/${id}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
